<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="row">
        <template v-for="(item, index) in interviewStatus">
          <div class="col-md-12" :key="'Company' + index">
            <div class="field">
              <ValidationProvider
                :name="`公司名稱${index}`"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    公司名稱
                    <span class="en-text">Company's name</span>
                  </span>
                </div>
                <div class="field-value">
                  <input
                    type="text"
                    maxlength="200"
                    autocomplete="off"
                    readonly
                    @focus="$common.removeReadonly($event)"
                    v-model="item.Company"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-md-6" :key="'IndustryCategory' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  產業類別
                  <span class="en-text">Industry category</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  placeholder="請選擇"
                  v-model="item.IndustryCategory"
                >
                  <el-option
                    label="電子產業 (Electronics Industry)"
                    :value="0"
                  />
                  <el-option
                    label="封測產業 (Semi-conductors Industry)"
                    :value="1"
                  />
                  <el-option
                    label="傳統產業 (Traditional Industries)"
                    :value="2"
                  />
                  <el-option label="其他產業 (Other Industries)" :value="3" />
                </el-select>
              </div>
            </div>
          </div>

          <div class="col-md-6" :key="'InterviewDate' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  面試日期
                  <span class="en-text">Application date</span>
                </span>
              </div>
              <div class="field-value">
                <el-date-picker
                  class="w-100"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="YYYY-MM-DD"
                  v-model="item.InterviewDate"
                />
              </div>
            </div>
          </div>

          <div class="col-md-6" :key="'County' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  縣市
                  <span class="en-text">Location (City)</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  filterable
                  placeholder="請選擇"
                  @change="changeCounty($event, index)"
                  v-model="item.CountyGuid"
                >
                  <el-option
                    v-for="city in cityOptions"
                    :key="city.Guid"
                    :label="city.Name"
                    :value="city.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="col-md-6" :key="'District' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  區域
                  <span class="en-text">Location (District)</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  filterable
                  placeholder="請先選擇縣市"
                  v-model="item.DistrictGuid"
                >
                  <el-option
                    v-for="district in item.districtOptions"
                    :key="district.Guid"
                    :label="district.Name"
                    :value="district.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="col-md-6" :key="'Position' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  面試職務
                  <span class="en-text">Applied occupation</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="text"
                  maxlength="50"
                  autocomplete="off"
                  readonly
                  @focus="$common.removeReadonly($event)"
                  v-model="item.Position"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6" :key="'InterviewResult' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  面試結果
                  <span class="en-text">Application result</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  placeholder="請選擇"
                  v-model="item.InterviewResult"
                >
                  <el-option label="錄取 (Select)" :value="0" />
                  <el-option label="不錄取 (Ineligible)" :value="1" />
                  <el-option label="未通知 (No notice)" :value="2" />
                </el-select>
              </div>
            </div>
          </div>
          <div class="col-md-6" :key="'BasicSalary' + index">
            <div class="field">
              <ValidationProvider
                class="w-100"
                :name="`底薪${index}`"
                :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span :style="{ color: fontColor }">
                    底薪
                    <span class="en-text">Basic salary</span>
                  </span>
                </div>
                <div class="field-value">
                  <input type="text" v-model.trim="item.BasicSalary" />
                </div>
                <span v-if="errors" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-md-6" :key="'Allowance' + index">
            <div class="field">
              <ValidationProvider
                class="w-100"
                :name="`津貼${index}`"
                :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span :style="{ color: fontColor }">
                    津貼
                    <span class="en-text">Allowance</span>
                  </span>
                </div>
                <div class="field-value">
                  <input type="text" v-model.trim="item.Allowance" />
                </div>
                <span v-if="errors" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-md-6" :key="'YearlySalary' + index">
            <div class="field">
              <ValidationProvider
                class="w-100"
                :name="`年薪${index}`"
                :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span :style="{ color: fontColor }">
                    年薪
                    <span class="en-text">Yearly Income</span>
                  </span>
                </div>
                <div class="field-value">
                  <input type="text" v-model.trim="item.YearlySalary" />
                </div>
                <span v-if="errors" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div
            v-if="interviewStatus.length > 1"
            class="col-md-6"
            :key="'button' + index"
          >
            <button type="button" class="del-btn" @click="del(index)">
              {{ $t("BUTTON.RESUME_DELETE") }}
            </button>
          </div>
        </template>
      </div>

      <div class="edit-btn-wrap">
        <!-- 新增 -->
        <button type="button" class="btn-sm add-btn" @click="add">
          {{ $t("BUTTON.RESUME_ADD") }}
        </button>
        <!-- 儲存 -->
        <button
          type="button"
          class="put-btn"
          @click="handleSubmit(saveInterviewStatus)"
        >
          {{ $t("BUTTON.RESUME_SAVE") }}
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId"],
  name: "AseIDLInterviewStatus",

  data() {
    return {
      interviewStatus: [],

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
    };
  },

  methods: {
    // 儲存 面試情況
    saveInterviewStatus() {
      let interviewStatus = this.interviewStatus.map((item) => {
        return {
          ...item,
          BasicSalary: item.BasicSalary
            ? Number(item.BasicSalary.replace(/,/g, ""))
            : null,
          Allowance: item.Allowance
            ? Number(item.Allowance.replace(/,/g, ""))
            : null,
          YearlySalary: item.YearlySalary
            ? Number(item.YearlySalary.replace(/,/g, ""))
            : null,
        };
      });

      this.$api.idl
        .putInterviewInfo(this.source, {
          Details: interviewStatus,
          UserId:
            this.source === "resume" ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "面試情況儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === "resume") {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getInterviewStatus();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 面試情況
    getInterviewStatus() {
      const candidate =
        this.source === "resume"
          ? this.$cookies.get("candidateId")
          : this.matchId;
      this.updateLoading(true);
      this.$api.idl
        .getInterviewInfo(this.source, candidate)
        .then((response) => {
          if (response.data.length > 0) {
            this.interviewStatus = response.data.map((item) => {
              return {
                ...item,
                districtOptions: [],
              };
            });
          } else {
            this.add();
          }
          this.updateLoading(false);
        });
    },

    // 變更 縣市
    changeCounty(target, index) {
      this.interviewStatus[index].CountyGuid = target;
      this.interviewStatus[index].DistrictGuid = null;
      this.interviewStatus[index].districtOptions = [];
    },

    add() {
      this.interviewStatus.push({
        id: null,
        DistrictGuid: null,
        districtOptions: [],
      });
    },

    del(index) {
      this.interviewStatus.splice(index, 1);
    },

    async getData() {
      await this.$store.dispatch("GetCity");
      await this.getInterviewStatus();
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  watch: {
    interviewStatus: {
      handler: function (newVal) {
        newVal.map((item) => {
          // 取得 區域
          if (item.CountyGuid && item.districtOptions.length === 0) {
            this.$api.address
              .getDistrict({
                CountyGuid: item.CountyGuid,
              })
              .then((response) => {
                item.districtOptions = response.data.map((item) => {
                  return {
                    Guid: item.Guid,
                    Name: item.Name,
                  };
                });
              });
          }
          // 底薪
          if (item.BasicSalary) {
            item.BasicSalary = this.$common.currencyThousands(
              String(item.BasicSalary)
            );
          }
          // 津貼
          if (item.Allowance) {
            item.Allowance = this.$common.currencyThousands(
              String(item.Allowance)
            );
          }
          // 年薪
          if (item.YearlySalary) {
            item.YearlySalary = this.$common.currencyThousands(
              String(item.YearlySalary)
            );
          }
        });
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters(["cityOptions"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getData();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}

button {
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 15px;
}

.del-btn {
  background: #ff3232;
  margin-top: 25px;
  color: #fff;
  margin-right: 10px;
}

.edit-btn-wrap {
  margin-top: 20px;
  button {
    background: #18c58b;
    color: #fff;
  }
  .add-btn {
    background: #fff;
    color: #000;
    margin-right: 5px;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}
</style>
